var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"dashboard"},_vm._l((_vm.parameters),function(param){return _c('Parameter',{key:param.id,attrs:{"title":param.title,"value":param.value,"unit":param.unit,"color":param.color}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }